import initFormsSubmit from "../components/initFormsSubmit.js";
import initModals from "../components/initModals.js";

document.addEventListener("DOMContentLoaded", () => {

    initFormsSubmit();
    initModals();

});
